import React from 'react'
import { InfoBlock } from '@mmsg/louie'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import ContactUsDialog from './dialog/contactUsDialog'
import { Icon } from 'icons'
import { ReactComponent as OlyLogo } from '../images/Oly.svg'
import { SocialMedia } from 'components/styledComponents/socialMedia'
import { NonGovdisclaimer } from 'components/disclaimers/nonGovdisclaimer'
import OlyLink from 'components/olyLink'
import { FooterImageStyled } from 'components/styledComponents/footerImage/footerImageStyled'
import * as E from './footerElements'

export const Footer = ({
  consultant,
  isAuthenticated,
  fromEmail,
  applicationRoles,
}) => {
  const { isConsultant } = applicationRoles
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const urlPath = isConsultant ? '/consultant/' : '/'
  let onHomeUrl = result === 'home'
  let onEstimatesUrl = result === 'estimates'

  //<TODO(VJ): the styled components have to be moved to a separate file once refactoring starts>

  return (
    <E.FooterBGDiv>
      <E.FooterContainer>
        {isAuthenticated && (
          <>
            <E.FooterLogoContainer>
              <OlyLogo style={{ height: '120px' }} />
            </E.FooterLogoContainer>
            {!fromEmail && (
              <Row>
                <Col sm={8} md={8} lg={8} className="mb-5">
                  <div className="mt-3 mb-3">
                    <InfoBlock
                      semiBold
                      maxWidth="500px"
                      infoHeader="Your dedicated consultant"
                      infoContent={`${consultant.firstName} is your personal consultant, dedicated to
              guiding you through this process. Want to loop someone into your
              decision? ${consultant.firstName} can help catch them up to speed.`}
                    />
                  </div>
                  <div className="mt-3 mb-3">
                    <InfoBlock
                      maxWidth="500px"
                      infoHeader="Consultant name"
                      infoContent={` ${consultant.firstName} ${consultant.lastName}`}
                    />
                  </div>
                  <div className="mt-3 mb-3">
                    <InfoBlock
                      maxWidth="500px"
                      infoHeader="Email"
                      infoContent={` ${consultant.email}`}
                    />
                  </div>
                  {consultant.telephone && (
                    <div className="mt-3 mb-3">
                      <InfoBlock
                        maxWidth="500px"
                        infoHeader="Phone Number"
                        infoContent={` ${consultant.telephone}`}
                      />
                    </div>
                  )}
                  <div className="mt-3">
                    <ContactUsDialog
                      theme="button"
                      extendInMob
                      disabled={isConsultant}
                      launchText="Request call back"
                    />
                  </div>
                </Col>
                <Col sm={4} md={4} lg={4} className="mt-3 mb-3">
                  <h5>Quick links</h5>

                  <E.QuickLinkBlock>
                    {onHomeUrl ? (
                      <E.FooterLinks href="#root">Home</E.FooterLinks>
                    ) : (
                      <E.FooterDomLinks to={`${urlPath}home`}>
                        Home
                      </E.FooterDomLinks>
                    )}
                    {onEstimatesUrl ? (
                      <E.FooterLinks href="#root">My quote</E.FooterLinks>
                    ) : (
                      <E.FooterDomLinks to={`${urlPath}estimates`}>
                        My quote
                      </E.FooterDomLinks>
                    )}

                    <OlyLink
                      linkUrl="https://www.oly.com.au/faq"
                      text="FAQs"
                      ariaLabel="Frequently asked questions"
                    />
                    {/* <OlyLink
                      linkUrl="https://www.oly.com.au/insurance-disclosures"
                      text="Insurance disclosures"
                    /> */}
                  </E.QuickLinkBlock>
                  <SocialMedia className="mt-4">
                    <a
                      href="https://www.facebook.com/oly.australia/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon iconType="IconFacebook" size={1.25} />
                    </a>
                    <a
                      href="https://www.instagram.com/oly.australia/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon iconType="IconInstagram" size={1.25} />
                    </a>
                    {/* <a
                      href="https://www.youtube.com/channel/UCV1zfFN1BZ0p_GojvEfSMDA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon iconType="IconYoutube" size={1.25} />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/oly/?originalSubdomain=au"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon iconType="IconLinkedin" size={1.25} />
                    </a> */}
                  </SocialMedia>
                </Col>
              </Row>
            )}
          </>
        )}
        <Col xs={12}>
          <E.FooterHr />
        </Col>
        <Row>
          <Col>
            <NonGovdisclaimer />
          </Col>
        </Row>
      </E.FooterContainer>
      <FooterImageStyled />
    </E.FooterBGDiv>
  )
}
function mapStateToProps(state) {
  const { consultant } = state
  const { isAuthenticated } = state.authentication
  const applicationRoles = state.applicationRoles

  return {
    consultant,
    isAuthenticated,
    applicationRoles,
  }
}

export default connect(mapStateToProps)(Footer)
